import { AfterViewInit, Component,  inject,  OnInit, Type, ViewChild } from "@angular/core";
import { WebhookCommonComponent } from "../common.components";
import { ComponentFactoryComponent } from "src/app/system-utils/component-factory/component-factory-view.component";
import { Subject } from "rxjs";


@Component({
    selector: 'webhook-form-component',
    templateUrl: './webhook-form-component.component.html',
    styleUrl: './webhook-form-component.component.scss',
    standalone: false
})

export class WebhookFormComponentComponent extends WebhookCommonComponent implements OnInit, AfterViewInit {
   
    @ViewChild("editComponent", { read: ComponentFactoryComponent })editContainer: ComponentFactoryComponent;
    component;
    componentOutput:Subject<any> = new Subject<any>();
    
    customComponentdata = {
        

    }

    
    ngOnInit(): void {
        super.ngOnInit();

        this.component =  this.dynamicLoader.getComponent(this.field.action?.component);
        
    }

    ngAfterViewInit(){
        let parameter = this.prepareInputData(this.field.action.data);
        this.dynamicLoader.loadParameter(this.editContainer.componentFactoryElement.instance,parameter);
        this.dynamicLoader.loadOutput(this.editContainer.componentFactoryElement.instance,this.field.action.events,this.map,this.rootForm, this);
    }

}